import { createTheme } from "@material-ui/core";

const theme = createTheme({
  contactURL: "https://www.socialscavenger.com/contact.html",
  dangerColor: "#ED1571",
  headerPadding: "24px",
  infoColor: "#01BEEB",
  linkButtonColor: "#282828",
  maxMobileWidth: "767px",
  minDesktopWidth: "768px",
  navbarColor: "#5605AA",
  placeholderColor: "#f5f5f5",
  playerUrl: `${process.env.REACT_APP_PREVIEW_URL}`,
  primaryColor: "#5605AA",
  successColor: "#93DD90",
  warningColor: "#F8EC00",
  errorColor: "#ED1671",
  headlinesColor: "#313131",
  accent1Color: "#FF00AA",
  accent2Color: "#01BEEB",
  accent3Color: "#93DD90",
  accent4Color: "#F8EC00",
  lightColor: "#F8F8F8",
  darkGreyColor: "#282828", 
  darkColor: "#5605AA",
  cardColor: "#E8F5FE",
  disabledColor: "#c8c8c8",
  realTimeDot: "#CE3031",
  white: "#FFF",
  black: "#000",
  rounded: {
    xs: "4px",
    sm: "7px",
    md: "14px",
    lg: "20px",
  },
  breakpoints: {
    values: {
      xs: 281,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
});

export default theme;
